import { Box, Typography, Stack, Button } from "@mui/material";
import { FaCircleCheck, FaCircleXmark } from "react-icons/fa6";
import { Link, useParams } from "react-router-dom";
import AppCard from "../../components/ui/AppCard";
import CustomContainer from "../../components/CustomContainer";

const StatusIcon = ({ success }) => (
    <Box sx={{ display: 'flex', color: success ? 'success.main' : 'error.main' }}>
        {success ? <FaCircleCheck size={64} /> : <FaCircleXmark size={64} />}
    </Box>
);

const StatusTitle = ({ success }) => (
    <Typography variant="h2" sx={{ mt: '1.25rem' }}>
        {success ? "Pedido efetuado com sucesso!" : "Ops, algo deu errado!"}
    </Typography>
);

const StatusMessage = ({ success }) => {
    const successMessage = (
        <Typography sx={styles.message}>
            Seu pedido foi registrado. Acompanhe a produção pelo seu histórico de pedidos.
        </Typography>
    );

    const errorMessage = (
        <Typography sx={styles.message}>
            Não conseguimos processar seu pedido no momento. Tente novamente mais tarde
            ou fale com a gente pelo e-mail comercial@inovartgold.com.br.
        </Typography>
    );

    return success ? successMessage : errorMessage;
};

const StatusActions = ({ success }) => (
    <Stack spacing={1.5} direction={{ xs: 'column', sm: 'row' }} mt={3}>
        {success ? (
            <>
                <Button component={Link} to="/pedidos" variant="contained" color="secondary">
                    Ver meus pedidos
                </Button>
                <Button component={Link} to="/produtos" variant="outlined" color="primary">
                    Continuar comprando
                </Button>
            </>
        ) : (
            <>
                <Button component={Link} to="/produtos" variant="contained" color="secondary">
                    Ver produtos
                </Button>
                <Button component={Link} to="/pedidos" variant="outlined" color="primary">
                    Meus pedidos
                </Button>
            </>
        )}
    </Stack>
);

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        px: 2,
        textAlign: 'center',
    },
    message: {
        mt: '1rem',
        color: 'text.secondary',
        maxWidth: 480,
    },
};

export default function OrderConfirmation() {
    const { status } = useParams();
    const orderSuccess = status === "success";

    return (
        <CustomContainer>
            <Box sx={styles.container}>
                <AppCard sx={{ maxWidth: 560, width: '100%', textAlign: 'center' }}>
                    <StatusIcon success={orderSuccess} />
                    <StatusTitle success={orderSuccess} />
                    <StatusMessage success={orderSuccess} />
                    <StatusActions success={orderSuccess} />
                </AppCard>
            </Box>
        </CustomContainer>
    );
}
